import { Text, TextType } from '@bit/first-scope.text';
import { useTheme } from '@cthings.co/styled-components';
import React, { FC } from 'react';
import styled from '@cthings.co/styled-components';
import { Textarea } from '../../../../components/textarea/Textarea';
import { TableInputType } from '../../types';
import { RequestBlock } from '../requestedBlock/RequestedBlock';

const Wrapper = styled.div`
  height: max-content;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledTextarea = styled(Textarea)`
  flex: 1;
  width: 100%;
` as any; // @TODO fix type

const StyledText = styled(Text)`
  flex: 1;
  word-break: break-all;
`;

interface TextfieldProps {
  value: {
    type: TableInputType;
    actual_value: { id: string; name: string } | null;
    requested_value: { id: string; name: string } | string | null;
    with_requested: boolean;
    is_editable: boolean;
  };
  state: any;
  setField: any;
  isEditInProcess?: boolean;
  isError?: boolean;
  placeholder?: string;
  isNumber?: boolean;
}

export const Textfield: FC<TextfieldProps> = ({
  value,
  state,
  setField,
  isEditInProcess,
  isError,
  placeholder,
  isNumber = false,
}) => {
  const theme = useTheme();
  const { gray1 } = theme.colors;

  const { actual_value, requested_value, with_requested, is_editable } = value;

  const setTextfieldValue = (actual_value: string) => setField({ ...value, actual_value });

  const validateReg = /^\d$/;

  return (
    <Wrapper>
      {is_editable && isEditInProcess ? (
        <StyledTextarea
          textValue={actual_value}
          changeValue={(value: any) => {
            isNumber ? validateReg.test(value) && setTextfieldValue(value) : setTextfieldValue(value);
          }}
          isError={isError}
          placeholder={placeholder}
          autoFocus
        />
      ) : (
        <StyledText type={TextType.TEXT_14_GRAY} color={gray1}>
          {actual_value ?? 'N/A'}
        </StyledText>
      )}
      {!isEditInProcess && with_requested && <RequestBlock requested_value={String(requested_value)} />}
    </Wrapper>
  );
};
